export const locale = {
  value: 'Link to Family Members',
};
